import { render } from "./MyPlaylists.vue?vue&type=template&id=400a9863"
import script from "./MyPlaylists.vue?vue&type=script&lang=js"
export * from "./MyPlaylists.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__